import dispatcher from '../../dispatcher';
import colorStore from '../../color/color.store';
import TweenMax from 'gsap/all';
import CSSPlugin from 'gsap/all';

var name = 'main-fallback';

var Decorator = function(component, options) {
	this._component = component;
	this._options = {}

	this._gradientVisible = false;
	this._gradientLocked = false;

	this.init = function() {
		if (this._fakeBg) return;
		this._fakeBg = document.createElement('div');
		this._fakeBg.style.position = 'absolute';
		this._fakeBg.style.left = 0;
		this._fakeBg.style.right = 0;
		this._fakeBg.style.top = 0;
		this._fakeBg.style.bottom = 0;
		this._fakeBg.transformOrigin = '0% 50%';

		TweenMax.set(this._fakeBg, {
			scaleX: 0
		});

		this._fakeBg.className = 'fake-bg';
		this._component.appendChild(this._fakeBg);
	}.bind(this);

	this.handleDispatcher = function(e) {
		var uniforms = this._uniforms;
		var self = this;

		if (e.type === 'gradient:lock') {
			this._gradientLocked = true;
		}

		if (e.type === 'gradient:unlock') {
			this._gradientLocked = false;
		}

		if (e.type === 'gradient:show') {
			if (this._gradientLocked ||
				this._gradientVisible) {
				return;
			}

			this._gradientVisible = true;
			this._fakeBg.style.transformOrigin = '0% 50%';

			TweenMax.killTweensOf(this._fakeBg);
			TweenMax.set(this._fakeBg, {
				scaleX: 0,
			});
			TweenMax.to(this._fakeBg, 0.65, {
				scaleX: 1,
			});
		}
		if (e.type === 'gradient:hide') {
			if (this._gradientLocked ||
				!this._gradientVisible) {
				return;
			}

			this._gradientVisible = false;
			this._fakeBg.style.transformOrigin = '100% 50%';

			TweenMax.killTweensOf(this._fakeBg);
			TweenMax.set(this._fakeBg, {
				scaleX: 1,
			});
			TweenMax.to(this._fakeBg, 0.8, {
				scaleX: 0,
				ease: window._easings.ease2
			});
		}
	}.bind(this);

	this.loop = function() {
		var gradient;
		var colorString;

		if (this._destruct) return;
		gradient = colorStore.getData().mixGradient;

		colorString = 'linear-gradient(to bottom right, '
			+ 'rgb(' + Math.floor(gradient[0].x * 255)
			+ ', ' + Math.floor(gradient[0].y * 255)
			+ ', '  + Math.floor(gradient[0].z * 255) + '), '
			+ 'rgb(' + Math.floor(gradient[1].x * 255)
			+ ', ' + Math.floor(gradient[1].y * 255)
			+ ', '  + Math.floor(gradient[1].z * 255) + '))';

		if (this._currentColor !== colorString) {
			this._currentColor = colorString;

			this._fakeBg.style.backgroundImage = colorString;
		}

		requestAnimationFrame(this.loop);
	}.bind(this);
}

var attach = function(component, options) {
	var decorator;

	if (!component._decorators) {
		component._decorators = {};
	}
	if (!component._decorators[name]) {
		component._decorators[name] = new Decorator(component, options);
	}
	decorator = component._decorators[name];

	decorator.init();
	decorator.loop();
	dispatcher.subscribe(decorator.handleDispatcher);

	return decorator;
}

var detach = function(component, options) {
	var decorator = component._decorators[name];
	decorator._destruct = true;
	dispatcher.unsubscribe(decorator.handleDispatcher);
}

export default {
	attach: attach,
	detach: detach
};